const _ = require('lodash');
const patterns = require('./net')();

const OK = 'GREEN';
const NOT_OK = 'RED';

const formatMobile = (value, config, withCountryCode) => {
  const parts = [];

  for (let a = 2; a < value.length; a = a + 2) {
    parts.push(value.substr(a, 2));
  }

  return `${withCountryCode ? '+31 6' : '06'} ${parts.join(' ')}`;
};

const format = (value, config, withCountryCode) => {
  if (/^mobiel$/i.test(config.type)) {
    return formatMobile(value, config, withCountryCode);
  }

  const subscriberNr = value.replace(config.pattern, '$2');

  const parts = [];

  if (subscriberNr.length % 2 === 0) {
    for (let a = 0; a < subscriberNr.length; a = a + 2) {
      parts.push(subscriberNr.substr(a, 2));
    }
  } else {
    parts.push(subscriberNr.substr(0, 3));
    for (let a = 3; a < subscriberNr.length; a = a + 2) {
      parts.push(subscriberNr.substr(a, 2));
    }
  }

  return `${withCountryCode ? '+31 ' : '0'}${value.replace(config.pattern, '$1')} ${parts.join(' ')}`;
};

module.exports = (input) => {
  if (input === null) {
    input = '';
  }
  let parsed = input.replace(/[-\s]/g, '');

  const nlWithCountryCode = /^((0031|\+?31)(\s?\(?(0)\)?\s?)?)([0-9]*)$/;

  if (nlWithCountryCode.test(parsed)) {
    parsed = parsed.replace(nlWithCountryCode, '0$5');
  }

  let matchingPattern;

  for (let index in patterns) {
    let pattern = patterns[index];
    if (pattern.pattern.test(parsed)) {
      matchingPattern = pattern;
      break;
    }
  }

  // Not a supported number, so we check if it's 'foreign'
  if (_.isNil(matchingPattern)) {
    // if foreign, than we accept it.
    if (/^\+|^00/.test(parsed)) {
      return {
        result: OK
      };
    }
  }

  let length = [10];

  if (_.has(matchingPattern, 'length')) {
    length = matchingPattern.length;
  }

  const result = !_.includes(length, parsed.length) ? NOT_OK : OK;

  if (result === OK && !_.isNil(matchingPattern)) {
    return {
      result,
      normalized: parsed.replace(matchingPattern.pattern, '31$1$2'),
      normalizedLocale: parsed.replace(matchingPattern.pattern, '0$1$2'),
      trunkPrefix: '0',
      lineType: matchingPattern.type,
      countryCallingCode: '31',
      areaCode: parsed.replace(matchingPattern.pattern, '$1'),
      formattedOutOfCountryCalling: format(parsed, matchingPattern, true),
      formattedPhoneNumber: format(parsed, matchingPattern, false),
      subscriberNumber: parsed.replace(matchingPattern.pattern, '$2')
    };
  }

  return {result};
};
